const config = {
	VISIBILITY_DURATION: 500
};

export default config;
